import { type MultiActionQuery, type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { updateProductVariantsStatuses } from '../../api';

type Options = {
    successText: string;
};

export async function changeProductVariantsStatus(
    query: MultiActionQuery,
    targetStatus: OpenApiSchemaProductVariant['status'],
    { successText }: Options
) {
    try {
        await updateProductVariantsStatuses({
            variant_ids: [],
            target_status: targetStatus,
            query,
        });

        showSuccess(successText);
    } catch (error) {
        showError({}, error);
    }
}
